import { formatDiffDate, ignoreTimezone } from "@enkor/date-fns";

import { ResponseEventCommentV1 } from "@models/data-contracts";

import ReplyViewModel from "./ReplyViewModel";

class CommentViewModel {
  id: number;
  authorName: string;
  authorId: number;
  content: string;
  profileImage?: string;
  commentedAt: string;
  replyList: ReplyViewModel[];

  static create(responseData: ResponseEventCommentV1) {
    const comment = new CommentViewModel();

    comment.id = responseData.id;
    comment.authorName = responseData.user.name;
    comment.authorId = responseData.user.id;
    comment.profileImage = responseData.user.url || "";

    comment.content = responseData.text;
    comment.commentedAt = formatDiffDate(
      ignoreTimezone(responseData.createdAt),
    );

    comment.replyList = responseData.replyList.map((reply) =>
      ReplyViewModel.create(reply),
    );

    return comment;
  }
}

export default CommentViewModel;
